import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

// Helper function to get auth headers with JWT token
const getAuthHeaders = () => {
    const token = localStorage.getItem('accessToken');
    return {
        'accept': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
    };
};

/**
 * Fetch all payment accounts for admin with pagination and optional filters
 * @param {Object} options - { page, limit, search, methodType }
 */
export const getAllPaymentAccountsAdmin = async ({ page = 1, limit = 10, search = '', methodType = '', name = '', email = '' } = {}) => {
    try {
        const params = new URLSearchParams();
        if (page) params.append('page', page.toString());
        if (limit && limit !== 10) params.append('limit', limit.toString());
        if (search && search.trim()) params.append('search', search.trim());
        if (name && name.trim()) params.append('name', name.trim());
        if (email && email.trim()) params.append('email', email.trim());
        if (methodType && methodType !== 'all') params.append('methodType', methodType);

        const queryString = params.toString();
        const url = `${apiUrlOne}/payment-accounts/admin/all${queryString ? `?${queryString}` : ''}`;

        const response = await axios.get(url, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching payment accounts:", error);
        throw error;
    }
};

/**
 * Fetch payment accounts by user ID
 * @param {string|number} userId
 */
export const getPaymentAccountsByUserId = async (userId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/payment-accounts/admin/${userId}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching payment accounts for user ${userId}:`, error);
        throw error;
    }
};

/**
 * Fetch single payment account by account ID
 * Endpoint: GET /api/v1/payment-accounts/:id
 * @param {string|number} id
 */
export const getPaymentAccountById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/payment-accounts/${id}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching payment account #${id}:`, error);
        throw error;
    }
};
